var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var detectChangedFields = function (object1, object2) {
    if (!object1 || !object2) {
        return [];
    }
    var keys = new Set(__spreadArray(__spreadArray([], Object.keys(object1), true), Object.keys(object2), true));
    var changedFields = Array.from(keys).filter(function (key) { return object1[key] !== object2[key]; });
    return changedFields;
};
